<template>
    <div class="d-block text-nowrap"
         v-if="motivationList">
        <span v-for="(m, index) in motivationList"
              :key="index"
              class="px-1 text-center"
              :class="getClass(m)">{{m | int}}
        </span>
    </div>
</template>

<script>
    export default {
        props: {
            motivationList: Array
        },
        methods: {
            getClass(m) {
                if (m >= 7)
                    return 'border-success bg-success text-light'
                else if (m >= 4)
                    return 'border-warning bg-warning text-light'
                else
                    return 'border-danger bg-danger text-light'
            }
        }
    }
</script>